import React from "react";
import Events from "../../../../../utilities/EventEmitter";
import { MapConstant } from "../../../../../lib/Map";
import styles from "../../../../../layout/componentHeaderStyles";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../../common/StyledToolTip";
import { withSnackbar } from "notistack";
import { compose } from "recompose";
import drawConstant from "./DrawConstant";
class DrawingToolbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      draw: null,
      activeDrawMode: null,
      map: null,
      activeFeatureId: null,
      enableDrawing: true,
      selectedFeatureId: null,
    };
  }

  componentDidMount() {
    Events.on(MapConstant.EVENT.SET_MAP_DRAW, this.updateDrawObject);
    Events.on(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP,
      this.handleCreatedDrawingOnMap
    );
    Events.on(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_SIDE_PANEL,
      this.drawingSelectedOnSidePanel
    );
  }

  componentWillUnmount() {
    Events.off(MapConstant.EVENT.SET_MAP_DRAW, this.updateDrawObject);
    Events.off(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_CREATED_ON_MAP,
      this.handleCreatedDrawingOnMap
    );
    Events.off(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_SIDE_PANEL,
      this.drawingSelectedOnSidePanel
    );
    this.clearMapEvents();
  }

  addMapEvents = () => {
    const { map } = this.state;
    if (map) {
      map.on(MapConstant.DRAWING_EVENTS.CREATE, this.drawUpdated);
      map.on(MapConstant.DRAWING_EVENTS.UPDATE, this.drawUpdated);
      map.on(MapConstant.DRAWING_EVENTS.DELETE, this.drawDeleted);
      map.on(
        MapConstant.DRAWING_EVENTS.SELECTION_CHANGE,
        this.drawSelectionChanged
      );
    }
  };

  drawingSelectedOnSidePanel = (featureIds, isEditMode = false) => {
    featureIds.length > 0 &&
      this.state.draw?.changeMode(this.state.draw?.modes?.SIMPLE_SELECT, {
        featureIds: featureIds,
      });
    if (isEditMode) {
      this.setState({
        activeFeatureId: featureIds[0],
        selectedFeatureId: featureIds[0],
        enableDrawing: false,
      });
    } else {
      this.setState({
        selectedFeatureId: featureIds[0],
      });
    }
    Events.emit(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_MAP,
      featureIds
    );
  };

  clearMapEvents = () => {
    const { map, draw } = this.state;
    if (map || draw) {
      map.off(MapConstant.DRAWING_EVENTS.CREATE, this.drawUpdated);
      map.off(MapConstant.DRAWING_EVENTS.UPDATE, this.drawUpdated);
      map.off(MapConstant.DRAWING_EVENTS.DELETE, this.drawDeleted);
      map.off(
        MapConstant.DRAWING_EVENTS.SELECTION_CHANGE,
        this.drawSelectionChanged
      );
    }
  };

  drawSelectionChanged = (event) => {
    if (Boolean(this.state.activeFeatureId)) {
      //check if there is an activeDrawing in progress, If true then prevent user from drawing or updating other drawings on map.
      if (
        event.features.length &&
        event.features[0].id !== this.state.activeFeatureId
      ) {
        this.preventDrawUpdate(event.features[0].id);
      }
      return;
    }
    Events.emit(
      drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_SELECTED_ON_MAP,
      event.features.map((feature) => feature.id)
    );
    this.setState({ selectedFeatureId: event.features[0]?.id ?? null });
  };

  preventDrawUpdate = () => {
    Events.emit(drawConstant.ROUTE_MAPPING_EVENTS.DRAWING_IN_PROGRESS);
    this.state.draw.changeMode(this.state.draw?.modes?.SIMPLE_SELECT, {
      featureIds: [this.state.activeFeatureId],
    });
  };

  updateDrawObject = ({ map, draw, drawComplete }) => {
    this.clearMapEvents();
    this.setState(
      {
        draw,
        map,
      },
      this.addMapEvents
    );
    this.drawComplete = drawComplete;
  };

  changeDrawMode = (drawMode) => {
    if (Boolean(this.state.activeFeatureId)) {
      return;
    }
    // if feature is drawing is present always go direct select mode(allows to move vertices) from simple select
    const { draw } = this.state;
    const [mode, options] =
      draw.modes.SIMPLE_SELECT === drawMode.mode &&
      draw.getAll().features.length
        ? [
            draw.modes.DIRECT_SELECT,
            { featureId: draw.getAll().features[0].id },
          ]
        : [drawMode.mode, {}];
    this.setState({
      activeDrawMode: mode,
    });
    draw.changeMode(mode, options);
  };

  clearDraw = () => {
    if (this.state.draw && this.state.selectedFeatureId) {
      const selectedIds = this.state.draw.getSelectedIds();
      if (selectedIds.length) {
        Object.values(this.state.draw.getAll().features).forEach((feature) => {
          if (selectedIds.includes(feature.id)) {
            this.drawDeleted(feature);
          }
        });
      }
    }
  };

  handleCreatedDrawingOnMap = (action) => {
    if (action === "save") {
      this.setState({
        activeFeatureId: null,
        enableDrawing: true,
      });
      return;
    }
    this.setState({
      activeFeatureId: null,
      enableDrawing: true,
      selectedFeatureId: null,
    });
    this.state.draw.changeMode(this.state.draw?.modes?.SIMPLE_SELECT, {});
  };

  drawUpdated = (event) => {
    this.drawComplete(event.features[0], event.type);
    this.setState({
      activeFeatureId: event.features[0].id,
      activeDrawMode: null,
      enableDrawing: false,
      selectedFeatureId: null,
    });
  };

  drawDeleted = (feature) => {
    if (this.state.activeFeatureId === feature.id) {
      this.setState({
        activeFeatureId: null,
        enableDrawing: true,
      });
    }
    this.drawComplete(feature, "delete");
  };

  render() {
    const { classes } = this.props;
    const { draw, activeDrawMode, enableDrawing } = this.state;
    return (
      <React.Fragment>
        {this.props.lasso && (
          <React.Fragment>
            <div
              className={`${classes.headerIconStyles} ${
                classes.iconLayout
              } glHeaderIcons ${
                draw && enableDrawing ? classes.iconStyle : classes.disableIcon
              } ${
                draw && activeDrawMode === draw.modes.DRAW_POLYGON
                  ? classes.activeIcon
                  : ""
              }`}
              onClick={() =>
                this.changeDrawMode({
                  mode: draw ? draw.modes.DRAW_POLYGON : null,
                })
              }
            >
              <Tooltip
                title={
                  enableDrawing
                    ? "Draw a shape"
                    : "Save or delete drawn polygon to draw a new one."
                }
              >
                <i className={`icon-lasso-select ${classes.actionIcon}`} />
              </Tooltip>
            </div>
          </React.Fragment>
        )}

        {this.props.delete && (
          <div
            className={`${classes.headerIconStyles} ${
              classes.iconLayout
            } glHeaderIcons ${
              this.state.selectedFeatureId
                ? classes.enabledIcon
                : classes.disableIcon
            }`}
            onClick={this.clearDraw}
          >
            <Tooltip
              title={
                this.state.selectedFeatureId
                  ? "Delete selected polygon"
                  : "Select a polygon to delete"
              }
            >
              <i className={`icon-icon_delete ${classes.actionIcon}`} />
            </Tooltip>
          </div>
        )}
      </React.Fragment>
    );
  }
}

export default compose(withSnackbar, withStyles(styles))(DrawingToolbox);
